var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addTags-container" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            title: "添加标签",
            visible: _vm.tagVisible,
            "close-on-click-modal": false,
            width: "30%",
            "close-on-press-escape": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.tagVisible = $event
            },
            close: _vm.close
          }
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "请选择", size: "small" },
              model: {
                value: _vm.uid,
                callback: function($$v) {
                  _vm.uid = $$v
                },
                expression: "uid"
              }
            },
            _vm._l(_vm.tagList, function(item) {
              return _c("el-option", {
                key: item.groupId,
                attrs: { label: item.groupName, value: item.groupId }
              })
            }),
            1
          ),
          _c(
            "div",
            { staticStyle: { margin: "30px 0", width: "100%" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.checkList,
                    callback: function($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList"
                  }
                },
                _vm._l(_vm.tagItemList, function(i, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "checkbox-wrap" },
                    [
                      _c("el-checkbox", { attrs: { label: i.tagId } }, [
                        _vm._v(_vm._s(i.tagName))
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "selected-bar-wrap" },
            [
              _c("div", { staticClass: "selected-bar-title" }, [
                _vm._v("已选：")
              ]),
              _vm._l(_vm.selectedTagNames, function(item, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    staticClass: "tag-item",
                    attrs: { size: "small" }
                  },
                  [_vm._v(_vm._s(item.tagName))]
                )
              })
            ],
            2
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.handleTags }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }